import i18next from "src/i18n/config";
import { z } from "zod";

export type FormValues = {
    ["android.app.extra.PROVISIONING_MODE"]: 1 | 2;
    ["android.app.extra.PROVISIONING_SKIP_USER_CONSENT"]: boolean;
    ["android.app.extra.PROVISIONING_SKIP_EDUCATION_SCREENS"]: boolean;
    ["android.app.extra.PROVISIONING_DEVICE_ADMIN_COMPONENT_NAME"]: string;
    ["android.app.extra.PROVISIONING_DEVICE_ADMIN_PACKAGE_CHECKSUM"]: string;
    ["android.app.extra.PROVISIONING_DEVICE_ADMIN_PACKAGE_DOWNLOAD_LOCATION"]: string;
    ["android.app.extra.PROVISIONING_SKIP_ENCRYPTION"]: boolean;
    ["android.app.extra.PROVISIONING_ADMIN_EXTRAS_BUNDLE"]: { ["UL"]: string } | undefined;
    ["android.app.extra.PROVISIONING_LEAVE_ALL_SYSTEM_APPS_ENABLED"]: boolean;
    ["android.app.extra.PROVISIONING_WIFI_SSID"]: string | undefined;
    ["android.app.extra.PROVISIONING_WIFI_PASSWORD"]: string | undefined;
    ["android.app.extra.PROVISIONING_WIFI_SECURITY_TYPE"]: (typeof securityTypeOptions)[number]["value"] | undefined;
};

export const initialValues: FormValues = {
    ["android.app.extra.PROVISIONING_DEVICE_ADMIN_COMPONENT_NAME"]: "com.emteria.mdm/com.emteria.mdm.MdmAdmin",
    ["android.app.extra.PROVISIONING_DEVICE_ADMIN_PACKAGE_CHECKSUM"]: "3Snji8qtYph7d8poJPAAjdukrOrDhGwJUqTym6aULYA=",
    ["android.app.extra.PROVISIONING_DEVICE_ADMIN_PACKAGE_DOWNLOAD_LOCATION"]:
        "https://apps.emteria.com/fdroid/emteria/repo/EmteriaMdm-v60100000.apk",
    ["android.app.extra.PROVISIONING_SKIP_ENCRYPTION"]: true,
    ["android.app.extra.PROVISIONING_ADMIN_EXTRAS_BUNDLE"]: undefined,
    ["android.app.extra.PROVISIONING_LEAVE_ALL_SYSTEM_APPS_ENABLED"]: false,
    ["android.app.extra.PROVISIONING_WIFI_SSID"]: undefined,
    ["android.app.extra.PROVISIONING_WIFI_PASSWORD"]: undefined,
    ["android.app.extra.PROVISIONING_WIFI_SECURITY_TYPE"]: undefined,
    ["android.app.extra.PROVISIONING_MODE"]: 1,
    ["android.app.extra.PROVISIONING_SKIP_USER_CONSENT"]: true,
    ["android.app.extra.PROVISIONING_SKIP_EDUCATION_SCREENS"]: true,
};

export const schema = z.object({
    ["android.app.extra.PROVISIONING_SKIP_ENCRYPTION"]: z.boolean(),
    ["android.app.extra.PROVISIONING_ADMIN_EXTRAS_BUNDLE"]: z.object({ "UL": z.string() }).optional(),
    ["android.app.extra.PROVISIONING_LEAVE_ALL_SYSTEM_APPS_ENABLED"]: z.boolean(),
    ["android.app.extra.PROVISIONING_WIFI_SSID"]: z.string().optional(),
    ["android.app.extra.PROVISIONING_WIFI_PASSWORD"]: z.string().optional(),
    ["android.app.extra.PROVISIONING_WIFI_SECURITY_TYPE"]: z.string().optional(),
});

export const qrCodeSize = 300;
export const qrCodeLevel = "L";
export const qrCodeBorder = 0;

export const encryptionOptions = [
    { label: i18next.t("modals:generateQrCode.input.encryption.options.skip"), value: 1 },
    { label: i18next.t("modals:generateQrCode.input.encryption.options.allow"), value: 0 },
];
export const systemAppsOptions = [
    { label: i18next.t("modals:generateQrCode.input.systemApplications.options.disable"), value: 0 },
    { label: i18next.t("modals:generateQrCode.input.systemApplications.options.enable"), value: 1 },
];
export const wifiOptions = [
    { label: i18next.t("modals:generateQrCode.input.wifiConnection.options.manual"), value: 0 },
    { label: i18next.t("modals:generateQrCode.input.wifiConnection.options.setupNow"), value: 1 },
];
export const versionMDM = [
    {
        label: "Emteria MDM v4.3.0",
        value: "v40300000",
        checksum: "jrvEXVtwzrwJcJBulYR7WYS1pjAzLnzBZsULiMb7X5w=",
        url: "https://apps.emteria.com/fdroid/emteria/repo/EmteriaMdm-v40300000.apk",
    },
    {
        label: "Emteria MDM v6.1.0",
        value: "v60100000",
        checksum: "3Snji8qtYph7d8poJPAAjdukrOrDhGwJUqTym6aULYA=",
        url: "https://apps.emteria.com/fdroid/emteria/repo/EmteriaMdm-v60100000.apk",
    },
];
export const securityTypeOptions = [{ label: "WPA", value: "WPA" }];

export const provisioningModeOptions = [
    { label: i18next.t("modals:generateQrCode.input.provisioningMode.options.fullyManagedDevice"), value: 1 },
    { label: i18next.t("modals:generateQrCode.input.provisioningMode.options.managedProfile"), value: 2 },
];
